import { md5 } from '@retailfe/retail-utils';

// 动态获取token的token，下面为默认值
export const GATEWAY_TOKEN = 'e130053e9ee342528e1864cba3975ffd';
// 业务参数的token，下面为默认值
export const GATEWAY_SIGNATURE_TOKEN = 'CT#e130053e9ee342528e1864cba3975ffd';

// 加密类型
export const SAFE_SIGN_TYPE = {
  ANTI_TAMPER: 0, // 防篡改
  PARAMETER_ENCRYPTION: 1, // 参数加密
};

/**
 * 用于生成signature
 * 添加拦截 Object.keys(b).sort(); https://cf.jd.com/pages/viewpage.action?pageId=246101966
 * 示例：var t= +new Date();var token =''; 'b&12&221' + token +t;
 * @param data，data为参数对象
 * @param t, query请求参数中的时间戳
 * @param token
 * @returns {*}
 */

export function createSignature({ data = {}, t = '', token = GATEWAY_SIGNATURE_TOKEN } = {}) {
  // token
  // params为query中参数，data为body中的参数
  // 从小到大排序后的数组对象，备用
  // let orderedOpts = []
  // 从小到大排序后的对象的值
  const orderedValues = [];
  // 初始值为空
  let paramString = '';
  // signature初始值
  let signature;
  // 只对 data为body中的参数 从小到大排序，取对应的值
  Object.keys(data)
    .sort()
    .forEach(key => {
      let value = data[key];
      // orderedOpts.push([key, value])
      // 过滤空值、null, undefined
      value = typeof value === 'undefined' ? null : value;
      // console.log('orderedOpts-key', key, value)

      if (value !== null && value !== '') {
        if (typeof value === 'object') {
          value = JSON.stringify(value);
        }
        // console.log('orderedValues-value', value)
        orderedValues.push(value);
      }
    });
  // 从小到大排序后取对应的值，存放数组中，如果有值用& 连接
  // console.log('orderedValues', orderedValues)

  if (orderedValues.length) {
    paramString = orderedValues.join('&');
  }
  t = t || '';

  // 只对请求参数encode转码
  paramString = encodeURIComponent(paramString) + token + t;

  // eslint-disable-next-line prefer-const
  signature = md5(paramString);

  return signature;
}

/**
 * safeParams 签名参数
 * @param safeTimestamp
 * @param safeSignature
 * @param safeSignType
 * @returns {{safeSignType: number, safeTimestamp: number, safeSignature}}
 */
export function createSafeParams({
  safeTimestamp = +new Date(),
  safeSignature,
  safeSignType = SAFE_SIGN_TYPE.ANTI_TAMPER,
} = {}) {
  return {
    safeTimestamp,
    safeSignature,
    safeSignType,
  };
}

/**
 * 请求动态token，需要用到的固定参数
 * @param token
 * @param needToken
 * @returns {string}
 */
export function getDynamicToken(token, { needToken = false } = {}) {
  // FIX needToken 用于网关请求动态token
  if (needToken) {
    // 请求获取动态token接口
    token = GATEWAY_TOKEN;
  }
  return token;
}

/**
 * 是否需要签名参数
 * @param params
 * @param safeParams
 * @returns {*}
 */
export function needSign(params = {}, safeParams = {}) {
  let _params = params;
  // params 可能为color 网关非get 请求中body参数，其值为json string
  if (typeof params === 'string') {
    _params = JSON.parse(params);
  }
  // 接口中默认都是需要签名滴，不要签名请设置URL参数中 needSign=false
  const { needSign = true } = _params || {};
  return needSign ? safeParams : params;
}

/**
 * color 网关签名生成
 * @param isMethodGet
 * @param params
 */
export function colorCreateSignature(isMethodGet = true, params = {}) {
  const { body = {}, t: safeTimestamp } = params;
  // FIX 业务token,获取不到走默认
  let token = window.__ENCRYPT_TOKEN__ || GATEWAY_SIGNATURE_TOKEN;
  let paramsBody = body || {};

  // body 非get提交，可能是json string
  if (!isMethodGet && typeof body === 'string') {
    paramsBody = JSON.parse(body);
  }
  // FIX needToken 用于网关请求动态token
  token = getDynamicToken(token, paramsBody);

  const safeSignature = createSignature({
    data: paramsBody,
    t: safeTimestamp,
    token,
  });
  const safeParams = createSafeParams({
    safeTimestamp,
    safeSignature,
  });

  let signBody = Object.assign({}, paramsBody, safeParams);
  // body 非get提交，可能是json string
  if (!isMethodGet) {
    signBody = JSON.stringify(signBody);
  }
  // 接口中默认都是需要签名滴，不要签名请设置body参数中: needSign=false
  params.body = needSign(body, signBody);
  return params;
}

/**
 * 封装 axios生成Signature 方法
 * @param config
 * @returns {*}
 */
export function axiosCreateSignature(config = {}) {
  // FIX 业务token,获取不到走默认
  let token = window.__ENCRYPT_TOKEN__ || GATEWAY_SIGNATURE_TOKEN;
  // params为query中参数，data为body中的参数
  const { params = {}, data = {} } = config || {};
  // t为时间戳
  // eslint-disable-next-line prefer-const
  let { t, requestId } = params || {};
  // FIX needToken 用于网关请求动态token
  token = getDynamicToken(token, params);
  // createSignature 只针对data中业务数据做加密
  t = t || requestId;
  const safeSignature = createSignature({ data, t, token });
  const safeParams = createSafeParams({
    safeTimestamp: t,
    safeSignature,
  });
  const signParams = Object.assign({}, params, safeParams);
  // 接口中默认都是需要签名滴，不要签名请设置URL参数中 needSign=false
  // FIX needSign
  config.params = needSign(params, signParams);
  return config;
}
